import { useState, useEffect } from 'react'
import { PRICE_SHEET_TYPES } from 'utils/constants'

export const useFilterPriceSheets = priceSheetsData => {
  const [priceSheetList, setPriceSheetList] = useState([])

  useEffect(() => {
    if (priceSheetsData?.Items?.length > 0) {
      const filteredPriceSheets = (priceSheetsData?.Items || [])
        .filter(priceSheet => priceSheet.type === PRICE_SHEET_TYPES.PRICE_LIST)
        .map(priceSheet => ({
          id: priceSheet.id,
          name: priceSheet.displayName,
        }))
      setPriceSheetList(filteredPriceSheets)
    }
  }, [priceSheetsData])

  return priceSheetList
}
